// extracted by mini-css-extract-plugin
export default {"pageLayout":"BiopharmaGroup-module__pageLayout___fGDmh"};